export enum PermissionCode {
  AllowAny = 0,
  SuperAdmin,
  BankVerify,
  KycRequests,
  Currency,
  BankManagement,
  KycProvider,
  Experts,
  UpdateRate,
  Report,
  WalletManagement,
  Customers,
  Withdraw,
  Deposit,
  PaymentProvider,
  PaymentMethod,
  MPGPartnerManagement,
  MPGTransactionsManagement,
  MPGLinkAccountManagement,
  Commissions,
  BlockchainNetwork,
  BlockchainNetworkCurrency,
  CryptoProvider,
  CryptoProviderAccount,
  CryptoWallet,
  CryptoWalletAddress,
  CryptoTransactionDeposit,
  CryptoTransactionWithdraw,
  CryptoWithdrawRequest,
  PaymentProviderBankAccounts,
  ReportsWalletBalance,
  WalletAmountFreezer,
  UserPlans,
  DirectDeposit,
  SystemGeneralSettings,
  WalletCorrection,
  WalletLockAmount,
  LoginProvider,
  Announcements,
}
